/**
 * Converts a list of font families to a string that can be used in CSS. Automatically quotes font names that require it.
 */
export function fontFamilyToString(fonts: readonly string[]): string {
	return fonts
		.map((font) => (/\s/u.test(font) ? `"${font}"` : font))
		.join(', ');
}
